import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { logger as reduxLogger } from 'redux-logger';
import reducers from './reducers';

import './i18n';

let middleware = [reduxThunk];

// Static import + import.meta.env.DEV, rather than the require() inside an if that
// CRA allowed. Webpack statically evaluated that condition and never resolved the
// dead require, which is why redux-logger could live in devDependencies; ESM
// imports are always resolved, so it moved to dependencies. The block itself is
// still dead-code-eliminated from production builds.
if (import.meta.env.DEV) {
    middleware = [...middleware, reduxLogger];
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(...middleware))
);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'));
